import { staticPageActions } from "../actionTypes";

export const fetchstaticPageInitiate = (data) => {
  return {
    type: staticPageActions.FETCH_STATIC_PAGE_INITIATE,
    payload: data,
  };
};

export const fetchstaticPageSuccess = (data) => {
  return {
    type: staticPageActions.FETCH_STATIC_PAGE_SUCCESS,
    payload: data,
  };
};


export const fetchtermsOfuseInitiate = (data) => {
  return {
    type: staticPageActions.FETCH_TERMS_OF_USE_INITIATE,
    payload: data,
  };
};

export const fetchtermsOfuseSuccess = (data) => {
  return {
    type: staticPageActions.FETCH_TERMS_OF_USE_SUCCESS,
    payload: data,
  };
};

export const fetchprivacyPolicyInitiate = (data) => {
  console.log("fetch privacypolicy initiate action")

  return {
    type: staticPageActions.FETCH_PRIVACY_POLICY_INITIATE,
    payload: data,
  };
};

export const fetchprivacyPolicySuccess = (data) => {
  console.log("fetch privacypolicy success action")
  return {
    type: staticPageActions.FETCH_PRIVACY_POLICY_SUCCESS,
    payload: data,
  };
};

export const addstaticPageInitiate = (data) => {
  return {
    type: staticPageActions.ADD_STATIC_PAGE_INITIATE,
    payload: data,
  };
};

export const addstaticPageSuccess = (data) => {
  return {
    type: staticPageActions.ADD_STATIC_PAGE_SUCCESS,
    payload: data,
  };
};

export const deletestaticPageInitiate = (data) => {
  return {
    type: staticPageActions.DELETE_STATIC_PAGE_INITIATE,
    payload: data,
  };
};

export const deletestaticPageSuccess = (data) => {
  return {
    type: staticPageActions.DELETE_STATIC_PAGE_SUCCESS,
    payload: data,
  };
};

export const editstaticPageInitiate = (data) => {
  return {
    type: staticPageActions.EDIT_STATIC_PAGE_INITIATE,
    payload: data,
  };
};

export const editstaticPageSuccess = (data) => {
  return {
    type: staticPageActions.EDIT_STATIC_PAGE_SUCCESS,
    payload: data,
  };
};